import React from 'react';
import { Grid, Badge, Table, TableBody, TableContainer, Typography } from '@mui/material';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import { useRecoilState } from 'recoil';
import Checkbox from '@mui/material/Checkbox';
import Btn from 'components/button';
import { OrderPayload, toggleModal, validOnboardingForm } from 'pages/project-onboarding/store';
import { serviceList, noConfigServiceList } from 'pages/project-onboarding/utils/constants';
import {
    getServiceName,
    getServiceVal,
    getServiceDisabled,
    getServiceChecked,
    getBadgeColor,
    getToolsOrderDisabled,
} from 'pages/project-onboarding/utils/getFunctions';
import { commonStyles as style } from 'assets/style';

export const ServiceResources = () => {
    const JFROG_ARTIFACTORY = 'JFrog Artifactory';
    const [order, setOrder] = useRecoilState(OrderPayload);
    const [isOpen, setIsOpen] = useRecoilState(toggleModal);
    const [validForm, setValidForm] = useRecoilState(validOnboardingForm);

    const setServiceResources = (event, service) => {
        setOrder({
            ...order,
            serviceResources: {
                ...order.serviceResources,
                ...(service === 'projectAdmin' && { isProjectAdmin: event.target.checked }),
                ...(service === 'boards' && { isBoard: event.target.checked }),
                ...(service === 'repos' && { isRepos: event.target.checked }),
                ...(service === 'pipelines' && { isPipelines: event.target.checked }),
                ...(service === 'sonarQube' && { isSonarQube: event.target.checked }),
                ...(service === 'artifactory' && { isArtifactory: event.target.checked }),
                // ...(service === 'securityTools' && { isSecurityTools: event.target.checked }),
                ...(service === 'testplans' && { isTestPlan: event.target.checked }),
            },
        });
    };

    const handleConfigure = (service) => {
        switch (service) {
            case 'projectAdmin':
                setIsOpen({ ...isOpen, isProjectAdminOpen: true });
                break;
            case 'sonarQube':
                setIsOpen({ ...isOpen, isSonarQubeOpen: true });
                break;
            case 'artifactory':
                setIsOpen({ ...isOpen, isArtifactoryOpen: true });
                break;
            // case 'securityTools':
            //     setIsOpen({ ...isOpen, isFortifySnykOpen: true });
            //     break;
            case 'testplans':
                setIsOpen({ ...isOpen, isTestPlanOpen: true });
                break;
            default:
                setIsOpen({ ...isOpen });
        }
    };

    React.useEffect(() => {
        if (order?.projectDetails) {
            setOrder({
                ...order,
                allowedAdminMembers:
                    order?.existingAdminMembers?.length > 0 ? order?.allowedAdminMembers - order?.existingAdminMembers?.length : order?.allowedAdminMembers,
            });

            if (order?.adoProjectType && !order?.isToolsProject) {
                setOrder({
                    ...order,
                    serviceResources: {
                        ...order.serviceResources,
                        // isProjectAdmin: order?.serviceResources?.isProjectAdmin ? true : order?.existingADOServices?.includes('projectAdmin'),
                        isBoard: order?.serviceResources?.isBoard ? true : order?.existingADOServices?.includes('boards'),
                        isRepos: order?.serviceResources?.isRepos ? true : order?.existingADOServices?.includes('repos'),
                        isPipelines: order?.serviceResources?.isPipelines ? true : order?.existingADOServices?.includes('pipelines'),
                    },
                });
            }
            if (order?.adoProjectType && order?.isToolsProject) {
                setOrder({
                    ...order,
                    serviceResources: {
                        ...order.serviceResources,
                        isBoard: order?.serviceResources?.isBoard ? true : order?.existingADOServices?.includes('boards'),
                    },
                });
            }
        }
    }, [order?.projectDetails, order?.adoProjectType]);

    React.useEffect(() => {
        if (!order?.serviceResources?.isProjectAdmin && !order?.isToolsProject) {
            setOrder({
                ...order,
                adminAccessMember: null,
                adminAccessMemberDetails: null,
                adminAccessMemberList: [],
                serviceResources: {
                    ...order.serviceResources,
                    isBoard: false,
                    isRepos: false,
                },
            });
        }
    }, [order?.serviceResources?.isProjectAdmin]);

    React.useEffect(() => {
        if (!order?.serviceResources?.isBoard) {
            setOrder({
                ...order,
                serviceResources: {
                    ...order.serviceResources,
                    isTestPlan: false,
                    // isSecurityTools: false,
                },
            });
        } else {
            setOrder({
                ...order,
                serviceResources: {
                    ...order.serviceResources,
                    isProjectAdmin: order?.isADOProject === 'no' && order?.isClarityId === 'no',
                },
            });
        }
    }, [order?.serviceResources?.isBoard]);

    React.useEffect(() => {
        if (!order?.serviceResources?.isRepos) {
            setOrder({
                ...order,
                serviceResources: {
                    ...order.serviceResources,
                    isPipelines: false,
                    isSonarQube: false,
                    // isSecurityTools: false,
                },
            });
        } else {
            setOrder({
                ...order,
                serviceResources: {
                    ...order.serviceResources,
                    isProjectAdmin: order?.isADOProject === 'no' && order?.isClarityId === 'no',
                },
            });
        }
    }, [order?.serviceResources?.isRepos]);

    React.useEffect(() => {
        if (!order?.serviceResources?.isPipelines) {
            setOrder({
                ...order,
                serviceResources: {
                    ...order.serviceResources,
                    isSonarQube: false,
                    // isSecurityTools: false,
                },
            });
        } else {
            setOrder({
                ...order,
                serviceResources: {
                    ...order.serviceResources,
                    isProjectAdmin: order?.isADOProject === 'no' && order?.isClarityId === 'no',
                    isRepos: true,
                },
            });
        }
    }, [order?.serviceResources?.isPipelines]);

    React.useEffect(() => {
        if (!order?.serviceResources?.isSonarQube) {
            setOrder({
                ...order,
                sonarQubeUser: null,
                sonarQubeUserDetails: null,
                sonarQubeUserList: [],
                sonarQubeCodeRepo: null,
                appShortName: null,
                newProjectOnboardMembers: false,
                newProjectOnboardServiceAccount: false,
                isServiceAccountExists: false,
            });
        } else {
            setOrder({
                ...order,
                sonarQubeCodeRepoList: [{ repo: '', isRepoTouched: false }],
                serviceResources: {
                    ...order.serviceResources,
                    isRepos: true,
                    isPipelines: true,
                },
            });
        }
    }, [order?.serviceResources?.isSonarQube]);

    React.useEffect(() => {
        if (!order?.serviceResources?.isArtifactory) {
            setOrder({
                ...order,
                progLanguage: null,
                progLanguageDetails: null,
                buildTool: null,
                buildToolDetails: null,
                packageType: null,
                packageTypeDetails: null,
                artifactoryUser: null,
                artifactoryUserDetails: null,
                artifactoryUserList: [],
            });
        }
    }, [order?.serviceResources?.isArtifactory]);

    // React.useEffect(() => {
    //     if (!order?.serviceResources?.isSecurityTools) {
    //         setOrder({
    //             ...order,
    //             onboardSAST: false,
    //             onboardSCA: false,
    //             organizationName: null,
    //             applicationUrl: null,
    //             securityTool: null,
    //             securityToolCodeRepoList: [{ repo: '', isRepoTouched: false }],
    //             sastMember: null,
    //             scaMember: null,
    //             sastMemberDetails: null,
    //             fortifyMembers: [],
    //             snykMembers: [],
    //             snykPreviewMembers: [],
    //         });
    //     } else {
    //         setOrder({
    //             ...order,
    //             serviceResources: {
    //                 ...order.serviceResources,
    //                 isBoard: true,
    //                 isRepos: true,
    //                 isPipelines: true,
    //             },
    //         });
    //     }
    // }, [order?.serviceResources?.isSecurityTools]);

    React.useEffect(() => {
        if (!order?.serviceResources?.isTestPlan) {
            setOrder({
                ...order,
                addTestPlanMembers: false,
                removeTestPlanMembers: false,
                hCode: null,
                hCodeDetails: null,
                testPlanUser: null,
                testPlanUserDetails: null,
                testPlanUserList: [],
                removedTestPlanUser: null,
                removedTestPlanUserDetails: null,
                removedTestPlanUserList: [],
                estimatedCost: {
                    details: [],
                    qty: null,
                    totalOneTimeCost: {
                        frequency: 'one time',
                        estCost: null,
                        currency: 'USD',
                    },
                    totalRecurringCost: {
                        frequency: 'monthly',
                        estCost: null,
                        currency: 'USD',
                    },
                    notes: 'Total Est. Cost does not include the DR/backup services cost & any Pepsico internal chargebacks',
                },
            });
            setValidForm({
                ...validForm,
                isDuplicateTestPlanUser: false,
                isTestPlanMaxMemberLimit: false,
                isDuplicateRemovedTestPlanUser: false,
                isRemovedTestPlanMaxMemberLimit: false,
            });
        } else {
            setOrder({
                ...order,
                serviceResources: {
                    ...order.serviceResources,
                    isBoard: true,
                },
            });
        }
    }, [order?.serviceResources?.isTestPlan]);

    const renderArtifactoryMessage = () => (
        <span style={{ fontSize: '10px' }}>
            For JFrog onboarding, please raise a request in DevX‑Launchpad for{' '}
            <a href={`${process?.env?.REACT_APP_DEVX_LAUNCHPAD}service-catalogue/jfrogArtifactoryOnboarding`} target="_blank" rel="noreferrer">
                JFrog Onboarding
            </a>{' '}
            and{' '}
            <a href={`${process?.env?.REACT_APP_DEVX_LAUNCHPAD}service-catalogue/jfrogAccessManagement`} target="_blank" rel="noreferrer">
                JFrog Access Management
            </a>
        </span>
    );

    const getCheckedVal = (isEnabled, service) => {
        if (isEnabled) {
            return getServiceVal(service, order?.serviceResources);
        }
        return false;
    };

    return (
        <Grid container spacing={2} data-testid="service-resources">
            <TableContainer>
                <Table size="small">
                    <TableBody style={{ width: '100%' }}>
                        {serviceList?.map((item, index) => (
                            <TableRow key={index}>
                                <TableCell align="left" style={{ width: '30%' }}>
                                    <Typography
                                        sx={{
                                            display: [JFROG_ARTIFACTORY].includes(getServiceName(item)) ? 'block' : 'flex',
                                            alignItems: 'center',
                                        }}
                                    >
                                        <Checkbox
                                            disabled={
                                                ['artifactory'].includes(item)
                                                    ? true
                                                    : getServiceDisabled(item, order?.existingADOServices, order) ||
                                                      getToolsOrderDisabled(item, order?.existingADOServices || [], order)
                                            }
                                            checked={
                                                order?.isADOProject === 'yes' ||
                                                (order?.isADOProject === 'no' && order?.clarityDetails && order?.clarityDetails?.devopsProject !== null)
                                                    ? getServiceChecked(item, order?.existingADOServices, order) ||
                                                      getCheckedVal(
                                                          order?.isToolsProject
                                                              ? !getToolsOrderDisabled(item, order?.existingADOServices || [], order)
                                                              : !getServiceDisabled(item, order?.existingADOServices, order),
                                                          item
                                                      )
                                                    : getServiceVal(item, order?.serviceResources)
                                            }
                                            onChange={(event) => setServiceResources(event, item)}
                                        />
                                        <span
                                            style={{
                                                whiteSpace: [JFROG_ARTIFACTORY].includes(getServiceName(item)) ? 'normal' : 'nowrap',
                                                overflow: 'hidden',
                                                color:
                                                    getServiceDisabled(item, order?.existingADOServices, order) === true ||
                                                    [JFROG_ARTIFACTORY].includes(getServiceName(item))
                                                        ? 'grey'
                                                        : 'black',
                                            }}
                                        >
                                            {getServiceName(item)}
                                        </span>
                                    </Typography>
                                </TableCell>
                                {item === 'artifactory' && (
                                    <TableCell colspan={2} align="left" style={{ width: '70%', padding: '6px 10px' }}>
                                        {renderArtifactoryMessage()}
                                    </TableCell>
                                )}
                                {item !== 'artifactory' && (
                                    <>
                                        <TableCell align="left" style={{ width: '50%', padding: '6px 10px' }}>
                                            {' '}
                                        </TableCell>

                                        <TableCell align="right" style={{ width: '20%', padding: '6px 5px' }}>
                                            {!noConfigServiceList?.includes(item) && (
                                                <Badge
                                                    color="error"
                                                    sx={style.tagBadge}
                                                    variant={
                                                        !getServiceVal(item, order?.serviceResources, order?.isToolsProject, order?.existingAdminMembers) ||
                                                        getServiceDisabled(item, order?.existingADOServices, order) ||
                                                        getBadgeColor(item, order, validForm)
                                                            ? 'standard'
                                                            : 'dot'
                                                    }
                                                >
                                                    <Btn
                                                        size="small"
                                                        disabled={
                                                            !getServiceVal(item, order?.serviceResources, order?.isToolsProject, order?.existingAdminMembers) ||
                                                            getServiceDisabled(item, order?.existingADOServices, order)
                                                        }
                                                        onClick={() => handleConfigure(item)}
                                                        variant="contained"
                                                        // color="cmpPrimary"
                                                        data-testid="configure-btn"
                                                        className="btn-disabled"
                                                        sx={style.primaryMediumButton}
                                                    >
                                                        CONFIGURE
                                                    </Btn>
                                                </Badge>
                                            )}
                                        </TableCell>
                                    </>
                                )}
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </Grid>
    );
};

export default React.memo(ServiceResources);
